// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-directive-image-previewer{position:fixed;top:0;left:0;width:100%;height:100%;z-index: 10000;}.vue-directive-image-previewer[disabled]{pointer-events:none}.vue-directive-image-previewer-background{position:absolute;width:100%;height:100%;background-color:rgba(0,0,0,.5);opacity:0}.vue-directive-image-previewer-body{width:100%;height:100%;z-index:100}.vue-directive-image-previewer-body img{position:absolute;z-index:100}", ""]);
// Exports
module.exports = exports;
